import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { endpoints } from "@/lib/api";
import Icon from "@/components/Icon";
import ProductCard from "@/components/ProductCard";
import { Reveal } from "@/lib/motionSafe";
import { useSettings } from "@/lib/useSettings";

export default function FeaturedProducts() {
  const [items, setItems] = useState(null);
  const { settings } = useSettings();

  useEffect(() => {
    endpoints
      .products({ featured: true })
      .then((data) => setItems(data.slice(0, 4)))
      .catch(() => setItems([]));
  }, []);

  if (items === null) return null;
  if (items.length === 0) return null;

  return (
    <section className="py-20 md:py-28 bg-slate-50" data-testid="featured-products">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal>
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
            <div className="max-w-2xl">
              <span className="aman-tag-dark">منتجات مميزة</span>
              <h2 className="font-heading mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A1628] leading-tight">
                {settings?.featured_products_title_ar || "أفضل الأجهزة التي نوصي بها"}
              </h2>
              <p className="mt-4 text-slate-600 leading-relaxed">
                {settings?.featured_products_desc_ar || "منتجات مختارة بعناية من علامات تجارية موثوقة، مع دعم فني كامل من فريقنا."}
              </p>
            </div>
            <Link
              to="/products"
              className="inline-flex items-center gap-1 text-[#0A1628] hover:text-[#00b8cc] transition-colors font-semibold"
              data-testid="featured-products-see-all"
            >
              تصفح كل المنتجات
              <Icon name="chevron-left" size={18} strokeWidth={2.5} />
            </Link>
          </div>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
          {items.map((p, i) => (
            <ProductCard key={p.id} product={p} delayMs={i * 80} />
          ))}
        </div>
      </div>
    </section>
  );
}
